"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _topnav_props = require("./topnav_props");

var _NavBarHeader = _interopRequireDefault(require("./component/NavBarHeader"));

var _NavBarCollapse = _interopRequireDefault(require("./component/NavBarCollapse"));

var _topnav_compact_props = _interopRequireDefault(require("./topnav_compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var TopNav =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TopNav, _PureComponent);

  function TopNav(props) {
    var _this;

    _classCallCheck(this, TopNav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TopNav).call(this, props));

    var _compactProps = (0, _topnav_compact_props["default"])(props),
        open = _compactProps.open;

    _this.state = {
      open: open
    };
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TopNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // 如果指定了，那就一直以参数的为准
      if (typeof nextProps.isOpen !== 'undefined' || typeof nextProps.open !== 'undefined') {
        this.setState({
          open: (0, _topnav_compact_props["default"])(nextProps)
        });
      }
    }
  }, {
    key: "handleOpen",
    value: function handleOpen(event) {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          open = _this$props.open;

      var _compactProps2 = (0, _topnav_compact_props["default"])(this.props),
          onOpen = _compactProps2.onOpen;

      var result = !this.state.open; // 如果没有自己设置，就默认组件内维护

      if (typeof isOpen === 'undefined' && typeof open === 'undefined') {
        this.setState({
          open: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onOpen)) {
        onOpen(event, result);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          title = _this$props2.title,
          rootUrl = _this$props2.rootUrl,
          logoUrl = _this$props2.logoUrl,
          logoAttribute = _this$props2.logoAttribute,
          headerProps = _this$props2.headerProps,
          collapseProps = _this$props2.collapseProps,
          list = _this$props2.list,
          searchValue = _this$props2.searchValue,
          onSearchChange = _this$props2.onSearchChange,
          LinkComponent = _this$props2.LinkComponent,
          propsLogoComponent = _this$props2.LogoComponent,
          propsLogoTitleComponent = _this$props2.LogoTitleComponent,
          _this$props2$titleEve = _this$props2.titleEvent,
          titleEvent = _this$props2$titleEve === void 0 ? {} : _this$props2$titleEve,
          _this$props2$logoEven = _this$props2.logoEvent,
          logoEvent = _this$props2$logoEven === void 0 ? {} : _this$props2$logoEven,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? '' : _this$props2$value,
          _this$props2$theme = _this$props2.theme,
          theme = _this$props2$theme === void 0 ? 'dark' : _this$props2$theme,
          _this$props2$fixed = _this$props2.fixed,
          fixed = _this$props2$fixed === void 0 ? true : _this$props2$fixed;
      var open = this.state.open;
      var LogoComponent = propsLogoComponent || LinkComponent;
      var LogoTitleComponent = propsLogoTitleComponent || LinkComponent;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-topnav', (_classNames = {}, _defineProperty(_classNames, "spaui-topnav-".concat(theme), true), _defineProperty(_classNames, 'is-fixed-top', fixed), _classNames)),
        needTitle: false
      }), _react["default"].createElement(_NavBarHeader["default"], _extends({
        title: title,
        rootUrl: rootUrl,
        logoUrl: logoUrl,
        logoAttribute: logoAttribute
      }, headerProps, {
        open: open,
        titleEvent: titleEvent,
        logoEvent: logoEvent,
        LinkComponent: LinkComponent,
        LogoComponent: LogoComponent,
        LogoTitleComponent: LogoTitleComponent,
        onOpen: this.handleOpen
      })), _react["default"].createElement(_NavBarCollapse["default"], _extends({
        searchValue: searchValue,
        onSearchChange: onSearchChange,
        list: list,
        open: open,
        value: value,
        LinkComponent: LinkComponent
      }, collapseProps)));
    }
  }]);

  return TopNav;
}(_react.PureComponent); // 组件标记


_defineProperty(TopNav, "propTypes", _topnav_props.propTypes);

_defineProperty(TopNav, "defaultProps", _topnav_props.defaultProps);

(0, _spauiUtils.setComponentMark)(TopNav, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = TopNav;
exports["default"] = _default;